<template>
	<v-sheet elevation="0">
		<v-tabs class="mt-4" v-model="tab" height="40px" slider-color="primary" color="black">
			<v-tab v-for="(item, i) in tabs" :key="i">
				{{ item.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab" class="pa-2">
			<v-tab-item>
				<table width="100%" class="mt-2 show-dialog-table show-dialog-table--form">
					<!-- TODO 適したフォームに変更する -->
					<tbody>
						<!-- TODO 想定受注番号 -->
						<ShowDetailRecord
							:columnName="'想定受注番号'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="matter.order_number"
						/>
						<ShowDetailRecord
							:columnName="'得意先名'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="matter.regular_customer_company.name"
						/>
						<ShowDetailRecord
							:columnName="'得意先郵便番号'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="matter.regular_customer_company.zipcode"
						/>
						<ShowDetailRecord
							:columnName="'得意先住所'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="`${matter.regular_customer_company.prefecture}${matter.regular_customer_company.city}${matter.regular_customer_company.address}${matter.regular_customer_company.building}}`"
						/>
						<ShowDetailRecord
							:columnName="'得意先電話番号'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="matter.regular_customer_company.phone"
						/>
						<ShowDetailRecord :columnName="'納入先名'">
							<template v-slot:value
								><v-text-field
									background-color="white"
									dense
									outlined
									hide-details
									v-model="matter.delivery_company_name"
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先郵便番号'">
							<template v-slot:value
								><v-text-field
									v-model="matter.zipcode"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先住所(都道府県)'">
							<template v-slot:value
								><v-text-field
									v-model="matter.delivery_prefecture"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先住所(市区町村)'">
							<template v-slot:value
								><v-text-field
									v-model="matter.delivery_city"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先住所(番地以下)'">
							<template v-slot:value
								><v-text-field
									v-model="matter.delivery_address"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先担当者'">
							<template v-slot:value
								><v-text-field
									v-model="matter.delivery_person_name"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納入先電話番号'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'エンドユーザー'">
							<template v-slot:value
								><v-text-field
									v-model="matter.customer_company.name"
									background-color="white"
									dense
									outlined
									hide-details
								></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'プラントメーカー'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details></v-text-field
							></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'備考'">
							<template v-slot:value
								><v-textarea background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>

						<!-- ここから製品 -->
						<!-- TODO v-forで回す -->
						<ShowDetailRecord
							:columnName="'製品1'"
							:thStyle="{ backgroundColor: 'white' }"
							:tdStyle="{
								backgroundColor: 'white',
								border: 'transparent',
								borderBottom: '1px solid whitesmoke',
							}"
						/>
						<ShowDetailRecord
							:columnName="'製品品番'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="'EA004176'"
						/>
						<ShowDetailRecord
							:columnName="'品名'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="'ゴム伸縮継手'"
						/>
						<ShowDetailRecord
							:columnName="'図版'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
							:value="'3EC0625'"
						/>
						<ShowDetailRecord :columnName="'数量'">
							<template v-slot:value>
								<v-text-field background-color="white" hide-details dense outlined />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'納期日'">
							<template v-slot:value>
								<v-text-field background-color="white" hide-details dense outlined /></template
						></ShowDetailRecord>
						<ShowDetailRecord :columnName="'単価'">
							<template v-slot:value>
								<v-text-field background-color="white" hide-details dense outlined suffix="円" />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'税抜き総額(自動計算)'"
							:value="`1,500,000円`"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'摘要1'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'摘要2'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-tab-item>
			<v-tab-item>
				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord :columnName="'見積No'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details
							/></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'注文書No'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details
							/></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'図書No'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details
							/></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'引合仕様検討No'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details
							/></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'原価No'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details
							/></template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'工事引合仕様書No.'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'顧客図書'">
							<template v-slot:value>
								<v-btn color="secondary">
									<v-icon class="mr-1">mdi-plus</v-icon>
									追加する
								</v-btn>
								<div class="mt-2">
									<v-chip color="primary" outlined close> 提出資料.pdf </v-chip>
								</div>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'ライニング母材手配者（缶体）'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'ライニング母材支給予定日（缶体）'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'承認予定日'">
							<template v-slot:value
								><v-text-field background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'社内図書'">
							<template v-slot:value>
								<v-btn color="secondary">
									<v-icon class="mr-1">mdi-plus</v-icon>
									追加する
								</v-btn>
								<div class="mt-2">
									<v-row no-gutters align="baseline">
										<h6 class="text-body-1 font-weight-bold mr-2">
											<!-- ファイル名 -->
											添付図.pdf
										</h6>
										<v-btn icon><v-icon>mdi-delete</v-icon></v-btn>
									</v-row>
									<v-textarea
										label="特記事項"
										class="mt-2"
										background-color="white"
										outlined
										hide-details
									/>
								</div>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'塗装'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-textarea label="補足事項" background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'工程写真'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-textarea label="補足事項" background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'水協検査'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-select
									label="水協検査方法"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<v-textarea class="mt-4" label="補足事項" background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'立会検査'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-textarea label="補足事項" background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'梱包指定'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-textarea label="補足事項" background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'出荷時添付書類'">
							<template v-slot:value>
								<v-radio-group row>
									<v-radio label="有" :value="true" />
									<v-radio label="無" :value="false" />
								</v-radio-group>
								<v-row no-gutters class="mt-2">
									<h6 class="text-body-1 font-weight-bold mr-2 mt-1">書類対象：</h6>
									<v-checkbox class="mr-2" label="納品書" /><v-checkbox
										class="mr-2"
										label="検査成績書"
									/><v-checkbox class="mr-2" label="現品票" /><v-checkbox
										class="mr-2"
										label="その他"
									/>
								</v-row>
								<v-text-field
									class="mt-2"
									label="種類部数"
									background-color="white"
									type="number"
									hide-spin-buttons
									dense
									outlined
									hide-details
								/>
								<v-textarea
									class="mt-2"
									label="補足事項"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'輸送手配'">
							<template v-slot:value>
								<v-select background-color="white" dense outlined hide-details />
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'輸送方法'">
							<template v-slot:value>
								<v-select background-color="white" dense outlined hide-details />
								<v-textarea
									class="mt-2"
									label="補足事項"
									background-color="white"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-tab-item>
		</v-tabs-items>
	</v-sheet>
</template>

<script>
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		order_confirmation: {
			type: Object,
			required: false,
			default: () => {},
		},
		matter_data: {
			type: Object,
			required: false,
			default: () => {},
		},
		existingFiles: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			tab: 0,
			tabs: [{ name: "受注内容" }, { name: "顧客要求事項" }],
			rules,
			common,
		}
	},

	methods: {
		removeFile(index) {
			this.orderConfirmation.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.orderConfirmation.files.push(file[1])
			})
		},
		deleteFile(index) {
			// TODO: ファイル削除処理
		},
	},
	computed: {
		orderConfirmation: {
			get() {
				return this.order_confirmation
			},
			set(newValue) {
				return this.$emit("update:order_confirmation", newValue)
			},
		},
		matter: {
			get() {
				return this.matter_data
			},
			set(newValue) {
				return this.$emit("update:matter_data", newValue)
			},
		},
	},
}
</script>
